module.exports = __webpack_public_path__ + "media/images/icons/youtube-a261e02a58556f42bcafe6b1141b7e71.svg";